import React, { Fragment } from "react";
import { useState, useEffect } from "react";
import {useDispatch, useSelector} from 'react-redux';
import { removeWshlist, addPokemonToCart } from "../../redux/actions/cartAndWishlistActions";
import { Link, useHistory } from "react-router-dom";


const WishListPage = (props) => {


    let history = useHistory();

    const dispatch = useDispatch()
    let {wishListItems}  = useSelector((state) => state.addToWishlist)


    const handleDeleteItem = (id) => {  
              dispatch(removeWshlist(id));
    }

    const handleBuyPokemon =(id) =>{

             dispatch(addPokemonToCart(id))
             history.push("/cart");
    }

    useEffect(() => {         
      }, [dispatch])

    return (
                <div className="wishListPageWrapper">
                        <div className="wishListItemsBox">
                            {
                                wishListItems && wishListItems.length? (
                                    wishListItems.map((poke) => {
                                        return (
                                                 <Fragment key={poke.id}>
                                                    <div className="wishListsItem" >
                                                        <div className="wishListsImage">
                                                            <div className="wishlistImage">
                                                                <img
                                                                 src={poke.sprites.front_default}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="wishListsName">
                                                            <span className="pokemonNameKey">
                                                               Pokemon Name: <span className="pokemonNameVal">{poke.name}</span>
                                                            </span>
                                                        </div>   
                                                        <div className="wishListsPrice">
                                                           <span className="pokemonNameKey">
                                                               Price: <span className="pokemonNameVal">{poke.price}</span>
                                                            </span>                                                   
                                                         </div>
                                                        <div className="wishListsDeploy">
                                                            <button className="btnDeploy"
                                                              onClick={() => handleBuyPokemon(poke.id)}
                                                            >
                                                                <span className="buyDeploy">Buy</span> and deploy to
                                                                <span className="buyDeployNet"> Network</span>
                                                            </button>
                                                        </div>
                                                        <div className="wishListsDelete">
                                                           <button className="btnDelete"
                                                                onClick={() => handleDeleteItem(poke.id)}
                                                           >                                                             
                                                                <span className="btnDeleteIcon"> Remove</span>from wishlist
                                                           </button> 
                                                     </div>
                                                    </div>
                                               </Fragment>
                                        )
                                    })
                                ) :
                                 (
                                 <>
                                    <div className="wishListisEmpty">
                                        <div><h1 className="wishListEmptyh1">your wishlist is empty</h1></div>
                                        <div>
                                            <Link to="/">
                                                <button className="wishListEmptyBtn">add pokemon(s) to your wishlist 
                                                <span className="wishListEmptySpan">and buy later</span>
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                 </>
                                )
                            }
                        </div>
                </div>
    )
}

export default WishListPage;
       